const formHelpers = require("coremh/components/formErrors.js");
const recaptcha = require("google/recaptcha");
const $formElementClass = ".form-control";
const $hpEmailSignUp = $("input[id*='hpEmailSignUp']");
const { setCSRFToken } = require("coremh/components/utils");
const { initNewsletterUserConsentEvents } = require("coremh/components/newsletter");

/**
 * appends params to a url
 * @param {string} data - data returned from the server's ajax call
 * @param {Object} button - button that was clicked for email sign-up
 */
const displayMessage = (data, button) => {
    $.spinner().stop();
    let status;

    if (data.success) {
        status = "btn-success";
        button.addClass(status).text(data.msg);
    }
};

/**
* Handles styling based on validity
* @param {object} $form - jQuery form element
* @param {string} status - class to be added to the element
* @param {string} oldstatus - class to be removed from the element
*/
const handleValidity = ($form, status, oldstatus) => {
    if ($form && $form.length) {
        $form.find($formElementClass).each((index, element) => {
            const formGroupSelector = ".form-group";
            const $element = $(element);
            if (oldstatus) {
                $element.parents(formGroupSelector)
                    .removeClass(oldstatus)
                    .addClass(status);
            } else {
                $element.not(`.${status}`).parents(formGroupSelector).removeClass(status);
                $element.filter(`.${status}`).parents(formGroupSelector).addClass(status);
            }
        });
    }
};

/**
* Sets the birthdate input field in the newsletter signup form
* @param {object} $form - jQuery form element
*/
const setBirthdateInput = ($form) => {
    if ($form && $form.length) {
        const day = $form.find("[id*='day']").val();
        const month = $form.find("[id*='month']").val();
        const year = $form.find("[id*='year']").val();
        const birthdate = [month, day, year].join("/");
        $form.find("input[id*='newsletter-birthdate']").val(birthdate);
    }
};

/**
* Validates the form and enables/disables the submit button
* @param {object} $this - the current element
*/
function validForm($this) {
    const $form = $this.closest("form");
    const $collapsibleEmail = $form.closest("input[id*='hpEmailSignUp']");
    const $btnSubmit = $form.closest(".btn-submit");
    const $daySelector = $form.closest(".daySelector");
    const $monthSelector = $form.closest(".monthSelector");
    const $yearSelector = $form.closest(".yearSelector");
    const $countryNewsletter = $form.closest(".countryNewsletter");
    const emailReg = new RegExp($(".newsletter-form").find("input[type='email']").attr("pattern"));
    let invalid= 0;

    $form.find("input:required").each(function () {
        if (
            $this.val() == "" ||
            !emailReg.test($collapsibleEmail.val()) ||
            $daySelector.find(".select2-selection__placeholder").text() == $daySelector.find("select[id*=-day]").data("placeholder") ||
            $monthSelector.find(".select2-selection__placeholder").text() == $monthSelector.find("select[id*=-month]").data("placeholder") ||
            $yearSelector.find(".select2-selection__placeholder").text() == $yearSelector.find("select[id*=-year]").data("placeholder") ||
            $countryNewsletter.find(".select2-selection__placeholder").text() == $countryNewsletter.find("select[id*=-countryField]").data("placeholder")
        ) {
            invalid++;
        }
    });

    if (invalid < 1) {
        $btnSubmit.removeClass("disabled").removeAttr("disabled");
    } else {
        $btnSubmit.addClass("disabled").attr("disabled", true);
    }
}

export default function () {
    const $dedicatedNewsletterForm = $("#dedicated-newsletter-form");

    // if the form exists reset it
    if ($dedicatedNewsletterForm.length) {
        // form reset
        $dedicatedNewsletterForm.find("input[type='text'], input[type='email']").val("");
    }

    $(".newsletter-form").find("select").on("select2:select", function () {
        const $this = $(this);

        validForm($this);
    });

    $(".newsletter-form input").on("keyup", function () {
        const $this = $(this);

        validForm($this);
    });

    $(".subscribe-email").on("click", function (e) {
        e.preventDefault();
        const $button = $(this);
        const $form = $button.closest("form");
        const formSelector = `form[id='${$form.attr("id")}']`;
        recaptcha.setToken({ formSelector: formSelector })
            .then(() => setCSRFToken({ $form: $form  }))
            .then(function() {
                if (!$form.find(".collapse").hasClass("show")) {
                    $(".js-fields-toggler").trigger("click");
                    $button.attr("disabled", true);
                } else {
                    $.spinner().start();
                    const $serverErrorField = $(".newsletter-server-error");
                    $serverErrorField.empty();
                    const url = $form.attr("action");
                    setBirthdateInput($form);
                    $.ajax({
                        url: url,
                        type: "post",
                        dataType: "json",
                        data: $form.serialize(),
                        success: function (data) {
                            if (!data.success) {
                                formHelpers.loadFormErrors($form, data);
                                handleValidity($form, "is-invalid");
                                $.spinner().stop();
                            } else {
                                formHelpers.clearPreviousErrors($form);
                                handleValidity($form, "is-valid", "is-invalid");
                                displayMessage(data, $button);
                            }
                        },
                        error: function (err) {
                            $.spinner().stop();
                            const response = err.responseJSON;
                            if (response.csrfError) {
                                window.location.href = response.redirectUrl;
                            }
                            const message = response.message;
                            if (message) {
                                $serverErrorField.append("<p>" + message + "</p>");
                            }
                        }
                    });
                }
            });
    });

    $(".form-title").on("select2:opening", function () {
        const $this = $(this);
        if ($this.find("option").prop("selected") === true) {
            $this
                .find("option[value='default']")
                .prop("selected", true)
                .trigger("change");
        }
    });

    $hpEmailSignUp.one("click", function () {
        var getAgeGateCookie = ("; " + document.cookie).split("; ageGate=").pop().split(";")[0];
        var codeCountryFromAgeGate = getAgeGateCookie.split("/")[3];
        var wantedCountry = "";
        var $this = $(this);
        var $form = $this.closest("form");
        var $countryField = $form.find("select[id*='-countryField']");

        if (codeCountryFromAgeGate && $countryField.val() === "") {
            $countryField.find("option").each(function () {
                if ($(this).val() === codeCountryFromAgeGate) {
                    wantedCountry = codeCountryFromAgeGate;
                }
            });
            $countryField.val(wantedCountry.trim()).trigger("change");
        }
    });

    $(".anchorNewsletter-focus").on("click", function() {
        $hpEmailSignUp.trigger("click");
    });

    initNewsletterUserConsentEvents();
}
